import type { ComboBoxValueComponentProps } from '../../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Tag } from '../../../../cdl/Tag/Tag';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';

interface ProductCategoryOptionProps
    extends ComboBoxValueComponentProps<{ label: string; value: string; inTank: boolean; disabled?: boolean }> {}

export const ProductCategoryOption = ({ option }: ProductCategoryOptionProps) => (
    <Box display="flex" alignItems="center" justifyContent="space-between" gap={8} minWidth={0} width="100%">
        <Text variant="small" truncated style={{ flex: 1 }}>
            {option.label}
        </Text>
        {option.inTank ? (
            <Box flexShrink={0}>
                <Tag disabled={option.disabled}>{translate('consumption.editPresets.inTank')}</Tag>
            </Box>
        ) : null}
    </Box>
);
